export const coreAddresses = {
  balanceTracker: "0x45ff89cD0e976392703048F4A4314A2010ee64b8",
  eVaultFactory: "0x2b21621b8Ef1406699a99071ce04ec14cCd50677",
  eVaultImplementation: "0x1974899F5d6B5a1f8E63b2e8Ad60e14BAC3E7980",
  eulerEarnFactory: "0x7670572aa76E6140400A948e7AAFAB0210a86d9f",
  evc: "0x01F594c66A5561b90Bc782dD0297f294cD668b64",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x4C3D26D7Eb6D5AA62CFD99624ad4Ff3351E4B129",
  sequenceRegistry: "0xF7a9F90b5ACb4EE4Cd536940142A04522D28e0Aa",
} as const
